import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Icon from "../../components/AppIcon";

const API_BASE = String(import.meta.env.VITE_API_BASE_URL || "http://localhost:8080").replace(/\/+$/, "");
const ACTIONS = { created: "Criado", updated: "Atualizado", deleted: "Excluído" };
const formatDate = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString("pt-BR");
};
const display = (value) => {
  if (value === undefined || value === null || value === "") return "—";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export default function PcpAuditHistory({ module }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [action, setAction] = useState("");
  const [expanded, setExpanded] = useState("");
  const load = useCallback(async () => {
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.get(`${API_BASE}/api/controle-producao/historico`, {
        params: { module, action, limit: 100 },
        withCredentials: true,
        timeout: 30000,
      });
      setItems(Array.isArray(data.items) ? data.items : []);
      setTotal(Number(data.total) || 0);
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Não foi possível carregar o histórico.");
    } finally {
      setBusy(false);
    }
  }, [module, action]);
  useEffect(() => { load(); }, [load]);
  return <section className="rounded-2xl border border-border bg-card p-5 shadow-sm">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 text-xl font-semibold"><Icon name="History" size={20}/> Histórico deste módulo</h2>
        <p className="mt-1 text-sm text-muted-foreground">Alterações registradas após a ativação: criação, edição e exclusão, com usuário, data e diferenças.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <select className="rounded-lg border border-border bg-background px-3 py-2 text-sm" value={action} onChange={(event) => setAction(event.target.value)} aria-label="Filtrar histórico por ação">
          <option value="">Todas as ações</option><option value="created">Criação</option><option value="updated">Edição</option><option value="deleted">Exclusão</option>
        </select>
        <button className="inline-flex items-center gap-2 rounded-lg border border-border px-3 py-2 text-sm hover:bg-muted" type="button" onClick={load} disabled={busy}><Icon name="RefreshCw" size={16}/>{busy ? "Atualizando" : "Atualizar"}</button>
      </div>
    </div>
    {error ? <div role="alert" className="mt-3 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div> : null}
    <p className="mt-3 text-xs text-muted-foreground">{total} registro(s) no histórico. Exibindo os 100 mais recentes conforme o filtro.</p>
    <div className="mt-3 max-h-[460px] space-y-2 overflow-y-auto">
      {!busy && !items.length ? <p className="rounded-xl border border-dashed border-border p-5 text-sm text-muted-foreground">Nenhuma alteração registrada neste módulo até o momento.</p> : null}
      {items.map((item) => <article key={item.id} className="rounded-xl border border-border bg-background px-4 py-3">
        <button type="button" onClick={() => setExpanded((current) => current === item.id ? "" : item.id)} className="flex w-full items-center justify-between gap-3 text-left">
          <div className="min-w-0">
            <p className="text-sm font-semibold">{ACTIONS[item.action] || item.action} · {item.label || item.recordId}</p>
            <p className="mt-1 text-xs text-muted-foreground">{item.actorName || "Sistema"} · {formatDate(item.date)}</p>
          </div><Icon name={expanded === item.id ? "ChevronUp" : "ChevronDown"} size={17}/>
        </button>
        {expanded === item.id ? <div className="mt-3 space-y-2 border-t border-border pt-3 text-xs">
          {item.fields?.length ? item.fields.map((field) => <div key={field} className="grid gap-1 rounded-lg bg-muted/40 p-2 sm:grid-cols-[140px_1fr]">
            <strong className="break-all">{field}</strong>
            <div className="min-w-0 break-words"><span className="text-muted-foreground">Antes:</span> {display(item.details?.[field]?.before)}<div><span className="text-muted-foreground">Depois:</span> {display(item.details?.[field]?.after)}</div></div>
          </div>) : <p>Nenhuma diferença adicional disponível.</p>}
        </div> : null}
      </article>)}
    </div>
  </section>;
}
